import React, {useState, useEffect, useRef} from 'react';
import FileUpload from "../../FileUploads/FileUpload";
import SearchLocation from "../../searchLocation/searchLocation";
import Loader from "../../../Loader/Loader";

const SiteDetails = ({
                         documentUploadUrlPublic,
                         documentUrlDataPublic,
                         dropdownValue,
                         handleInput,
                         locationCity = [],
                         locationZone,
                         locationArea,
                         zones = [],
                         areas = [],
                         locationPinCode,
                         siteImages,
                         handleAddSiteImages,
                         removeSiteImages,
                         handleSiteImagesInput,
                         accountDetailsByIdData,
                         inputList,
                         setSiteImages,
                         isView=false,
                         stateRegionDetails=[],
                         stateAndRegion,
                         isEdit=false
                     }) => {

    const [cityId, setCityId] = useState(0)
    const [zoneId, setZoneId] = useState(0)
    const [areaId, setAreaId] = useState(0)
    const [regionId, setRegionId] = useState(0)
    const [carOccupancyRate, setCarOccupancyRate] = useState(0)
    const [bikeOccupancyRate, setBikeOccupancyRate] = useState(0)
    const [locationType, setLocationType] = useState('')
    const [pincodeValue, setPincodeValue] = useState('')
    const [stateId, setStateId] = useState(0)
    const [city, setCity] = useState('');
    const [geostate, setGeostate] = useState('');
    const [state, setState] = useState('')
    const [regionName, setRegion] = useState('')

    const handlePincode = async (pincode) => {
        if (pincode === '') return false
        setPincodeValue(pincode)
        handleInput(pincode, 'client_pincode')
        let res = await locationPinCode(pincode)
        setCity(res[0]?.city_name !== undefined ? res[0]?.city_name : '')
        setGeostate(res[0]?.state_name !== undefined ? res[0]?.state_name : '')
        handleInput(res[0]?.geo_city_id, 'geographical_city_id')
        handleInput(res[0]?.geo_state_id, 'geographical_state_id')
    }

    useEffect(() => {
        handlePincode(pincodeValue)
    }, [pincodeValue])

    const [lat, setLat] = useState('')
    const [long, setLong] = useState('')
    const ref = useRef(null);
    const [click, setClick] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        },500)
    }, [])

    useEffect(() => {
        if (click !== '' && !isView) {
            ref.current.click();
        }
    }, [click])

    useEffect(() => {
        (async () => {
            handleInput(cityId, 'city_id')
            await locationZone(cityId !== 0 ? cityId : accountDetailsByIdData?.city_id)
            await stateAndRegion(cityId !== 0 ? cityId : accountDetailsByIdData?.city_id)
        })()
    }, [cityId])

    useEffect(() => {
        (async () => {
            handleInput(zoneId, 'zone_id')
            await locationArea(zoneId !==0 ? zoneId : accountDetailsByIdData?.zone_id)
        })()
    }, [zoneId])

    useEffect(() => {
        handleInput(areaId, 'area_id')
    }, [areaId])

    useEffect(() => {
        handleInput(carOccupancyRate, 'car_occupancy_rate_id')
    }, [carOccupancyRate])

    useEffect(() => {
        handleInput(bikeOccupancyRate, 'bike_occupancy_rate_id')
    }, [bikeOccupancyRate])

    useEffect(() => {
        handleInput(locationType, 'location_type')
    }, [locationType])

    useEffect(() => {
        setState('')
        setRegion('')
        if(stateRegionDetails?.state_id !== undefined){
            handleInput(stateRegionDetails?.state_id, 'state_id')
            handleInput(stateRegionDetails?.region_id, 'region')
            setState(stateRegionDetails?.state_name)
            setRegion(stateRegionDetails?.region_name)
        }
    }, [stateRegionDetails])

    const [optOption, setOptOption] = useState({
        address2: '',
        currentLocation: '',
    });
    const handleCurrentLocationBlur = (latlng = null) => {
        if (latlng !== null && latlng !== undefined) {
            setLong(latlng?.lng)
            setLat(latlng?.lat)
            handleInput(latlng?.lng, 'longitude')
            handleInput(latlng?.lat, 'latitude')
        }
    };

    const handleCurrentLocationChange = (value) => {
        setOptOption({ ...optOption, currentLocation: value });
        handleInput(value, 'current_location')
        if(!isEdit){
            handleInput(value, 'address_1')
        }
    };

    const [isInputError, setIsInputError] = useState({
        latError: false,
        longError: false,
        pinError: false,
        crl: false,
        isPinNotFound: false,
    });


    useEffect(() => {
        if (accountDetailsByIdData !== [] && accountDetailsByIdData?.account_type_id !== undefined) {
            if(accountDetailsByIdData?.current_location !== undefined &&
                accountDetailsByIdData?.current_location !== null &&
                accountDetailsByIdData?.current_location !== ''){
                setOptOption({ ...optOption, currentLocation: accountDetailsByIdData?.current_location });
            }

            if(accountDetailsByIdData?.latitude !== undefined &&
                accountDetailsByIdData?.latitude !== null &&
                accountDetailsByIdData?.latitude !== ''){
                setLat(accountDetailsByIdData?.latitude)
            }

            if(accountDetailsByIdData?.longitude !== undefined &&
                accountDetailsByIdData?.longitude !== null &&
                accountDetailsByIdData?.longitude !== ''){
                setLong(accountDetailsByIdData?.longitude)
            }

            handleInput(accountDetailsByIdData?.region, 'region')
            handleInput(accountDetailsByIdData?.parking_agency, 'parking_agency')
            handleInput(accountDetailsByIdData?.security_agency, 'security_agency')
            handleInput(accountDetailsByIdData?.no_of_parking_revenue, 'no_of_parking_revenue')
            handleInput(accountDetailsByIdData?.no_of_parking_floor, 'no_of_parking_floor')
            handleInput(accountDetailsByIdData?.no_of_exist_gate, 'no_of_exist_gate')
            handleInput(accountDetailsByIdData?.no_of_entered_gate, 'no_of_entered_gate')
            handleInput(accountDetailsByIdData?.no_of_bike_slots, 'no_of_bike_slots')
            handleInput(accountDetailsByIdData?.no_of_car_slots, 'no_of_car_slots')
            handleInput(accountDetailsByIdData?.city_id, 'city_id')
            handleInput(accountDetailsByIdData?.zone_id, 'zone_id')
            handleInput(accountDetailsByIdData?.area_id, 'area_id')
            handleInput(accountDetailsByIdData?.address_1, 'address_1')
            handleInput(accountDetailsByIdData?.address_2, 'address_2')
            handleInput(accountDetailsByIdData?.latitude, 'latitude')
            handleInput(accountDetailsByIdData?.longitude, 'longitude')
            if(accountDetailsByIdData?.pincode !== undefined && accountDetailsByIdData?.pincode !== null){
                handlePincode(accountDetailsByIdData?.pincode)
            }
            handleInput(accountDetailsByIdData?.pincode, 'pincode')
            setPincodeValue(accountDetailsByIdData?.pincode)
            handleInput(accountDetailsByIdData?.geographical_city_id, 'geographical_city_id')
            handleInput(accountDetailsByIdData?.geographical_city_id, 'geographical_city_id')
            handleInput(accountDetailsByIdData?.latitude, 'lat')
            handleInput(accountDetailsByIdData?.longitude, 'long')
            handleInput(accountDetailsByIdData?.site_images, 'site_image')
        }

    }, [accountDetailsByIdData])

    useEffect(() => {
        if(accountDetailsByIdData?.site_images !== undefined){
            const tempArray = JSON.parse(JSON.stringify(accountDetailsByIdData?.site_images)) ?? []; // deep copy
            let len = tempArray.length
            for (let i = 0; i < len; i++) {
                setClick(i)
            }
        }
    }, [accountDetailsByIdData?.site_images])

    useEffect(() => {
        if(accountDetailsByIdData?.site_images !== undefined){
            const tempArray = JSON.parse(JSON.stringify(accountDetailsByIdData?.site_images)) ?? []; // deep copy
            let len = tempArray.length
            delete siteImages[0]['url']
            for (let i = 0; i < len; i++) {
                if (i === 0) {
                    siteImages[0]['url'] = tempArray[i]['url']
                } else {
                    siteImages.push({url: tempArray[i]['url']})
                }
            }

            setSiteImages(tempArray)
        }
    }, [accountDetailsByIdData?.site_images, click])

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div className="col-sm-6 float-field mtk-01 d-mtk-03">
                <select className="form-control form-control-user" required onChange={(e) => {
                    setLocationType(e.target.value)
                }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                    <option value="">Select Location Type</option>
                    <option value="small">Small</option>
                    <option value="medium">Medium</option>
                    <option value="large">Large</option>
                    {accountDetailsByIdData?.ev_vehicle === 'Small' ?
                        <>
                            <option value="Small" selected>Small</option>
                            <option value="Medium">Medium</option>
                            <option value="Large">Large</option>
                        </> :
                        accountDetailsByIdData?.ev_vehicle === 'Medium' ?
                            <>
                                <option value="Small">Small</option>
                                <option value="Medium" selected>Medium</option>
                                <option value="Large">Large</option>
                            </> :
                            accountDetailsByIdData?.ev_vehicle === 'Large' ?
                                <>
                                    <option value="Small">Small</option>
                                    <option value="Medium" selected>Medium</option>
                                    <option value="Large" selected>Large</option>
                                </> :
                                <>
                                    <option value="Small">Small</option>
                                    <option value="Medium" >Medium</option>
                                    <option value="Large" >Large</option>
                                </>
                    }
                </select>
                <label className="large-label float-lb">
                    Location Type <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <SearchLocation
                handleCurrentLocationBlur={handleCurrentLocationBlur}
                isError={isInputError.crl}
                value={optOption.currentLocation}
                handleCurrentLocationChange={handleCurrentLocationChange}
                isView={isView}
                setPincodeValue={setPincodeValue}
            />
            <div className="col-sm-6 float-field mt-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(val) => {
                           handleInput(val, 'lat')
                       }}
                       value={lat}
                       required
                       disabled={isView}
                />
                <label className="large-label float-lb">
                    Latitude <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mt-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(val) => {
                           handleInput(val, 'long')
                       }}
                       value={long}
                       required
                       disabled={isView}
                />
                <label className="large-label float-lb">
                    Longitude <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mt-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(e) => {
                           handleInput(e.target.value, 'address_1')
                       }}
                       required
                       value={inputList[0]?.address_1}
                       disabled={isView}
                />
                <label className="large-label float-lb">
                    Address Line <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mt-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(e) => {
                           handlePincode(e.target.value)
                       }}
                       required
                       value={pincodeValue}
                       disabled={isView}
                />
                <label className="large-label float-lb">
                    Pincode <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mtk-025 d-mtk-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(e) => {
                           handleInput(city, 'geographical_city_id')
                       }}
                       disabled
                       value={city}
                       required
                />
                <label className="large-label float-lb">
                    Geographical City <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mt-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(e) => {
                           handleInput(geostate, 'geographical_state_id')
                       }}
                       disabled
                       value={geostate}
                       required
                />
                <label className="large-label float-lb">
                    Geographical State <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mtk-025 d-mtk-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(e) => {
                           handleInput(e.target.value, 'state_id')
                           setStateId(stateRegionDetails?.state_id)
                       }}
                       required
                       value={state}
                       disabled
                />
                <label className="large-label float-lb">
                    State <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mtk-025 d-mtk-1">
                <input type="text"
                       className="form-control form-control-user"
                       placeholder=" "
                       onChange={(e) => {
                           handleInput(e.target.value, 'region')
                           setRegionId(stateRegionDetails?.region_id)
                       }}
                       value={regionName}
                       required
                       disabled
                />
                <label className="large-label float-lb">
                    Region <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            {/*<div className="col-sm-6 float-field mt-1">*/}
            {/*    <input type="text"*/}
            {/*           className="form-control form-control-user"*/}
            {/*           placeholder=" "*/}
            {/*           onChange={(e) => {*/}
            {/*               handleInput(e.target.value, 'address_2')*/}
            {/*           }}*/}
            {/*           value={inputList[0]?.address_2}*/}
            {/*    />*/}
            {/*    <label className="large-label float-lb">*/}
            {/*        Address of site 2*/}
            {/*    </label>*/}
            {/*</div>*/}
            <div className="col-sm-6 float-field mtk-05 d-mtk-1">
                <select className="form-control form-control-user"
                        onChange={(e) => setCityId(e.target.value)} required disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                    <option value="">Select City</option>
                    {locationCity.map((val) => {
                        return (
                            <>
                                {(parseInt(accountDetailsByIdData?.city_id) === val?.id) ?
                                    <>
                                        return (
                                        <option value={val?.id} selected>{val.name}</option>
                                        )
                                    </>    :
                                    <option value={val?.id}>{val.name}</option>
                                }
                            </>
                        )
                    })}
                </select>
                <label className="large-label float-lb">
                    City <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mt-3 d-mtk-1">
                <select className="form-control form-control-user"
                        onChange={(e) => setZoneId(e.target.value)} required disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                    <option value="">Select Zone</option>
                    {zones.map((val) => {
                        return (
                            <>
                                {(parseInt(accountDetailsByIdData?.zone_id) === val?.id) ?
                                    <>
                                        return (
                                        <option value={val?.id} selected>{val.name}</option>
                                        )
                                    </>    :
                                    <option value={val?.id}>{val.name}</option>
                                }
                            </>
                        )
                    })}
                </select>
                <label className="large-label float-lb">
                    Zone <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            <div className="col-sm-6 float-field mt-3 d-mtk-1">
                <select className="form-control form-control-user"
                        onChange={(e) => setAreaId(e.target.value)} required disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                    <option value="">Select Area/Sector</option>
                    {areas.map((val) => {
                        return (
                            <>
                                {(parseInt(accountDetailsByIdData?.area_id) === val?.id) ?
                                    <>
                                        return (
                                        <option value={val?.id} selected>{val.name}</option>
                                        )
                                    </>    :
                                    <option value={val?.id}>{val.name}</option>
                                }
                            </>
                        )
                    })}
                </select>
                <label className="large-label float-lb">
                    Area/Sector <i className="bi bi-asterisk astrick-icon"></i>
                </label>
            </div>
            {isView && inputList[0]?.no_of_car_slots !== null && inputList[0]?.no_of_car_slots !=='' &&
                <div className="col-sm-6 float-field mtk-075 d-mtk-1">
                    <input type="number"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'no_of_car_slots')
                           }}
                           value={inputList[0]?.no_of_car_slots}
                           disabled={isView}
                    />
                    <label className="large-label float-lb">
                        No of Car Slot
                    </label>
                </div>
            }
            {!isView &&
                <div className="col-sm-6 float-field mtk-075 d-mtk-1">
                    <input type="number"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'no_of_car_slots')
                           }}
                           value={inputList[0]?.no_of_car_slots}
                           disabled={isView}
                    />
                    <label className="large-label float-lb">
                        No of Car Slot
                    </label>
                </div>
            }
            {isView && inputList[0]?.no_of_bike_slots !== null && inputList[0]?.no_of_bike_slots !== '' &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="number"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'no_of_bike_slots')
                           }}
                           value={inputList[0]?.no_of_bike_slots}
                           disabled={isView}
                    />
                    <label className="large-label float-lb">
                        No of Bike Slot
                    </label>
                </div>
            }
            {!isView &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="number"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'no_of_bike_slots')
                           }}
                           value={inputList[0]?.no_of_bike_slots}
                    />
                    <label className="large-label float-lb">
                        No of Bike Slot
                    </label>
                </div>
            }
            {isView && inputList[0]?.no_of_entered_gate !== null && inputList[0]?.no_of_entered_gate !== '' &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="number"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'no_of_entered_gate')
                           }}
                           value={inputList[0]?.no_of_entered_gate}
                           disabled={isView}
                    />
                    <label className="large-label float-lb">
                        No of Enter Gate
                    </label>
                </div>
            }
            {!isView &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="number"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'no_of_entered_gate')
                           }}
                           value={inputList[0]?.no_of_entered_gate}
                    />
                    <label className="large-label float-lb">
                        No of Enter Gate
                    </label>
                </div>
            }
            {isView && inputList[0]?.no_of_exist_gate !== null && inputList[0]?.no_of_exist_gate !== '' &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="number"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'no_of_exist_gate')
                           }}
                           value={inputList[0]?.no_of_exist_gate}
                           disabled={isView}
                    />
                    <label className="large-label float-lb">
                        No of Exist Gates
                    </label>
                </div>
            }
            {!isView &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="number"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'no_of_exist_gate')
                           }}
                           value={inputList[0]?.no_of_exist_gate}
                    />
                    <label className="large-label float-lb">
                        No of Exist Gates
                    </label>
                </div>
            }
            {isView && inputList[0]?.no_of_parking_floor !== null && inputList[0]?.no_of_parking_floor !== '' &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="number"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'no_of_parking_floor')
                           }}
                           value={inputList[0]?.no_of_parking_floor}
                           disabled={isView}
                    />
                    <label className="large-label float-lb">
                        No of Parking Floor
                    </label>
                </div>
            }
            {!isView &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="number"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'no_of_parking_floor')
                           }}
                           value={inputList[0]?.no_of_parking_floor}
                    />
                    <label className="large-label float-lb">
                        No of Parking Floor
                    </label>
                </div>
            }
            {isView && inputList[0]?.no_of_parking_revenue !== null && inputList[0]?.no_of_parking_revenue !== '' &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="number"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'no_of_parking_revenue')
                           }}
                           value={inputList[0]?.no_of_parking_revenue}
                           disabled={isView}
                    />
                    <label className="large-label float-lb">
                        Parking Revenue
                    </label>
                </div>
            }
            {!isView &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="number"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'no_of_parking_revenue')
                           }}
                           value={inputList[0]?.no_of_parking_revenue}
                    />
                    <label className="large-label float-lb">
                        Parking Revenue
                    </label>
                </div>
            }
            {isView && inputList[0]?.security_agency !== null && inputList[0]?.security_agency !== '' &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="text"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'security_agency')
                           }}
                           value={inputList[0]?.security_agency}
                           disabled={isView}
                    />
                    <label className="large-label float-lb">
                        Security Agency
                    </label>
                </div>
            }
            {!isView &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="text"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'security_agency')
                           }}
                           value={inputList[0]?.security_agency}
                    />
                    <label className="large-label float-lb">
                        Security Agency
                    </label>
                </div>
            }
            {isView && inputList[0]?.parking_agency !== null && inputList[0]?.parking_agency !== '' &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="text"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'parking_agency')
                           }}
                           value={inputList[0]?.parking_agency}
                           disabled={isView}
                    />
                    <label className="large-label float-lb">
                        Parking Agency
                    </label>
                </div>
            }
            {!isView &&
                <div className="col-sm-6 float-field mt-1">
                    <input type="text"
                           className="form-control form-control-user"
                           placeholder=" "
                           onChange={(e) => {
                               handleInput(e.target.value, 'parking_agency')
                           }}
                           value={inputList[0]?.parking_agency}
                    />
                    <label className="large-label float-lb">
                        Parking Agency
                    </label>
                </div>
            }
            {isView && inputList[0]?.car_occupancy_rate_id !== null && inputList[0]?.car_occupancy_rate_id !== '' &&
                <div className="col-sm-6 float-field mtk-05 d-mtk-03">
                    <select className="form-control form-control-user" onChange={(e) => {
                        setCarOccupancyRate(e.target.value)
                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                        <option value="">Select Occupancy rate</option>
                        {dropdownValue?.occupancy!== undefined && dropdownValue?.occupancy.map((val) => {
                            return (
                                <>
                                    {(accountDetailsByIdData?.car_occupancy_rate_id === val?.id) ?
                                        <>
                                            return (
                                            <option value={val?.id} selected>{val.name}</option>
                                            )
                                        </>    :
                                        <option value={val?.id}>{val.name}</option>
                                    }
                                </>
                            )
                        })}
                    </select>
                    <label className="large-label float-lb">
                        Car Occupancy rate
                    </label>
                </div>
            }
            {!isView &&
                <div className="col-sm-6 float-field mtk-05 d-mtk-03">
                    <select className="form-control form-control-user" onChange={(e) => {
                        setCarOccupancyRate(e.target.value)
                    }}>
                        <option value="">Select Occupancy rate</option>
                        {dropdownValue?.occupancy!== undefined && dropdownValue?.occupancy.map((val) => {
                            return (
                                <>
                                    {(accountDetailsByIdData?.car_occupancy_rate_id === val?.id) ?
                                        <>
                                            return (
                                            <option value={val?.id} selected>{val.name}</option>
                                            )
                                        </>    :
                                        <option value={val?.id}>{val.name}</option>
                                    }
                                </>
                            )
                        })}
                    </select>
                    <label className="large-label float-lb">
                        Car Occupancy rate
                    </label>
                </div>
            }

            {isView &&
                <div className="col-sm-6 float-field mtk-01 d-mtk-1">
                    <select className="form-control form-control-user" onChange={(e) => {
                        setBikeOccupancyRate(e.target.value)
                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                        <option value="">Select Occupancy rate</option>
                        {dropdownValue?.occupancy!== undefined && dropdownValue?.occupancy.map((val) => {
                            return (
                                <>
                                    {(accountDetailsByIdData?.bike_occupancy_rate_id === val?.id) ?
                                        <>
                                            return (
                                            <option value={val?.id} selected>{val.name}</option>
                                            )
                                        </>    :
                                        <option value={val?.id}>{val.name}</option>
                                    }
                                </>
                            )
                        })}
                    </select>
                    <label className="large-label float-lb">
                        Bike Occupancy rate
                    </label>
                </div>
            }
            {!isView &&
                <div className="col-sm-6 float-field mtk-01 d-mtk-1">
                    <select className="form-control form-control-user" onChange={(e) => {
                        setBikeOccupancyRate(e.target.value)
                    }}>
                        <option value="">Select Occupancy rate</option>
                        {dropdownValue?.occupancy!== undefined && dropdownValue?.occupancy.map((val) => {
                            return (
                                <>
                                    {(accountDetailsByIdData?.bike_occupancy_rate_id === val?.id) ?
                                        <>
                                            return (
                                            <option value={val?.id} selected>{val.name}</option>
                                            )
                                        </>    :
                                        <option value={val?.id}>{val.name}</option>
                                    }
                                </>
                            )
                        })}
                    </select>
                    <label className="large-label float-lb">
                        Bike Occupancy rate
                    </label>
                </div>
            }
            {siteImages.map((val, i) => {
                return (
                    <>
                        {!isView &&
                            <div className="col-sm-6 mt-2 d-mtk-01">
                                <FileUpload
                                    id={"addAttachment" + i}
                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(val) => {
                                        handleSiteImagesInput(i, val)
                                    }}
                                    prefilledFilename={val?.url !== '' && val?.url !== null ? "Uploaded Image" : ''}
                                >
                                    Site Image
                                </FileUpload>
                            </div>
                        }
                        <div className="col-sm-6 mt-2">
                            <img src={val?.url}/>
                        </div>
                        {!isView &&
                            <div className="btn-box mb-4">
                                {siteImages.length !== 1 &&
                                    <>
                                        <button
                                            onClick={(e) => removeSiteImages(e, i)}
                                            className="btn btn-sm btn-danger ml-3 btn-ar">Remove
                                        </button>
                                    </>
                                }
                                {siteImages.length - 1 === i &&
                                    <button
                                        className="btn btn-sm btn-primary ml-3 btn-ar" ref={ref}
                                        onClick={() => handleAddSiteImages()}>Add More
                                    </button>}
                            </div>
                        }
                    </>
                )
            })}
        </>
    );
}
export default SiteDetails;